import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const FeaturesSection = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: false
  });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    } else {
      controls.start('hidden');
    }
  }, [controls, inView]);

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: { 
      y: 0, 
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 10
      }
    }
  };

  return (
    <section className="py-16 md:py-24 bg-zinc-900" id="features" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.h2 
          className="text-3xl md:text-4xl font-bold text-white text-center mb-0"
          initial={{ opacity: 0 }}
          animate={controls}
          variants={itemVariants}
        >
          See Memic in Action
        </motion.h2>
        
        <motion.img 
          src="/images/my_video.gif" 
          alt="AI avatar conversation demonstration" 
          className="w-full max-w-lg mx-auto mb-16 rounded-xl shadow-2xl"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={controls}
          variants={itemVariants}
          transition={{ delay: 0.2 }}
        />
        
        <motion.div 
          className="flex flex-wrap justify-center gap-6 md:gap-8 mb-16"
          variants={containerVariants}
          initial="hidden"
          animate={controls}
        >
          {[
            {
              image: "/images/onboarding/2.png",
              title: "Create Your Digital Clone",
              description: "Upload your photos and let the AI craft a digital version of you that looks just like you."
            },
            {
              image: "/images/onboarding/3.png",
              title: "Create Your Minion's Avatar",
              description: "Transform the essence of your minion into a digital avatar, capturing their likeness and memories with AI-driven accuracy."
            },
            {
              image: "/images/onboarding/4.png",
              title: "Share Your Created Avatars",
              description: "Share your created avatars or invite your friends to experience your digital twin."
            }
          ].map((item, index) => (
            <motion.div 
              key={index}
              className="bg-zinc-800 rounded-xl shadow-xl overflow-hidden transform hover:scale-105 transition-transform duration-300 max-w-xs"
              variants={itemVariants}
              whileHover={{ 
                scale: 1.05, 
                boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.2)",
                y: -5
              }}
            >
              <img 
                src={item.image} 
                alt={`${item.title} onboarding screen`} 
                className="w-full object-contain h-96"
              />
              <div className="p-4 text-center">
                <h3 className="text-xl font-semibold text-white">{item.title}</h3>
                <p className="text-gray-400 mt-2">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturesSection; 